/**
 * Where a displayed matrix row physically LIVES: in the matrix the K-10 assignment points at, or in
 * one of its parents along the K-7 inheritance chain.
 *
 * ── WHY THIS IS WORTH A CHIP OF ITS OWN
 *
 * 127 of the 128 matrices of the reference stock inherit. "Where does this value actually come
 * from" is therefore the NORMAL question a reader has, not the exception, and a row that does not
 * say whether it is the matrix's own or an inherited one leaves them to open the parent chain by
 * hand to find out. {@link INHERITED} also tells them where NOT to edit: changing an inherited row
 * changes it for every child matrix that inherits the same one.
 *
 * ── DISPLAY VOCABULARY, DERIVED IN EXACTLY ONE PLACE
 *
 * The backend's assembly service compares the row's own matrix id against the ASSIGNED matrix id,
 * and that comparison is the only place this value is formed. No surface may re-derive it from the
 * two ids it can see — it would be a second source of truth for a question that already has an
 * answer on the wire.
 *
 * Position-based mirror of the backend enum
 * {@code com.mvs.backend.cp.enums.ProvisionConfigurationOrigin}. The backend persists and sends the
 * ordinal, so the declaration order below MUST match the backend exactly and new constants MUST
 * only be appended at the end — never inserted between existing ones, which would silently re-map
 * every stored value (02-datenmodell.md §0.5/§2).
 *
 * The German captions ("Eigene Zeile", "Geerbt") live on the backend as `@UiEnumValueInfo(uiLabel =
 * …)` and reach a surface through the sibling `originInfo` block of the field. Read them there; do
 * not build a label map for this enum.
 */
export enum ProvisionConfigurationOrigin {

    /** Ordinal 0 — "Eigene Zeile". The row stands in the assigned matrix itself. */
    OWN,

    /** Ordinal 1 — "Geerbt". The row was inherited from a parent matrix along the K-7 chain. */
    INHERITED
}
